import { Center, Text, Timeline } from '@mantine/core';
import { HiMiniChevronDown, HiMiniChevronRight } from 'react-icons/hi2';
import React from 'react';
import VersionTimelineItem from '@/pages/Editor/components/VersionHistory/VersionHistoryModal/VersionTimelineItem.tsx';
import { AutomationVersionSimple } from '@/types/automations.ts';

type props = {
  date: string;
  versions: AutomationVersionSimple[];
  publishedVersion?: AutomationVersionSimple;
  latestVersion?: AutomationVersionSimple;
};

const backgroundColor = 'var(--mantine-color-blue-filled)';

const VersionsByDate = ({ date, versions, publishedVersion, latestVersion }: props) => {
  const [opened, setOpened] = React.useState<boolean>(false);

  const Icon = opened ? HiMiniChevronDown : HiMiniChevronRight;
  // const backgroundColor = opened
  //   ? 'var(--mantine-color-blue-filled)'
  //   : 'var(--mantine-color-blue-1)';

  return (
    <>
      <Timeline.Item
        bullet={
          <Center
            w="24px"
            h="14px"
            style={{ backgroundColor: backgroundColor, borderRadius: '10px' }}
          >
            <Icon size={10} color="white" />
          </Center>
        }
        onClick={() => setOpened(!opened)}
        style={{ cursor: 'pointer', paddingTop: '2px', paddingLeft: '6px', marginTop: '16px' }}
      >
        <Text size="sm">
          {date}
          {` (${versions.length} versions)`}
        </Text>
      </Timeline.Item>
      {opened &&
        versions.map((version) => (
          <VersionTimelineItem
            key={version.id}
            version={version}
            publishedVersion={publishedVersion}
            latestVersion={latestVersion}
            publishedVersions={false}
          />
        ))}
    </>
  );
};

export default VersionsByDate;
